import AddingUsedAssemblyMaterial from './AddingUsedAssemblyMaterial';

export default AddingUsedAssemblyMaterial;